import { createStore } from "vuex";
import search from "./search";
import loginAndOut from "./loginAndOut";
import agency from "./modules/agency";
import admin from "./modules/admin";
import table from "./modules/table";
import lead from "./modules/lead";
import customer from "./modules/customer";
import statistics from "./modules/statistics";
import rawLead from "./modules/rawLead";
import leadGenerator from "./modules/leadGenerator";
import marketing from "./modules/marketing";
import leadTracker from "./modules/leadTracker";
import whatsApp from "./modules/whatsApp";

export default createStore({
  modules: {
    search,
    loginAndOut,
    agency,
    admin,
    customer,
    table,
    lead,
    statistics,
    rawLead,
    leadGenerator,
    marketing,
    leadTracker,
    whatsApp,
  },
});
